var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-header"},[_c('div',{staticClass:"rating-header__image",class:_vm.classImageType},[_c('img',{attrs:{"src":_vm.imageBg}})]),_c('div',{staticClass:"rating-header__title",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }